import { PayrightPlusRatesSuccessResponse } from "./merchant-api";

export const getMerchantRates = (payrightPlusRates: PayrightPlusRatesSuccessResponse | null): PayrightPlusRatesSuccessResponse => {
  const local = localStorage.getItem('payrightPlusRates');
  if (!local) {
    return payrightPlusRates as PayrightPlusRatesSuccessResponse;
  }
  return JSON.parse(local);
};

